function SignalAnalogSummary() {
/// <summary>
    /// This object provides the menu handling for the VC.Widget.Signal.SignalAnalog.Summary.vb.<br/>
    /// Depending on the clicked menu item it loads various visuals. 
    /// Author: AFU<br />
    /// Date: 27.2.2017<br />
    /// Copyright ©: EUDT GmbH 2017 <br />
    /// Version-History:<br />
    /// **********************************************************************<br />
    /// *** v1.1.0 - 27.2.2017                                               *<br />
    /// **********************************************************************<br />
    /// * -  basic functionality                                 *<br />
    /// **********************************************************************<br />
    /// </summary>
}

SignalAnalogSummary.prototype = new vcTemplate();

SignalAnalogSummary.prototype.init = function () {
    /// <summary>
    /// This function sets specific widths, heights and inits the specific event handlers.<br/>
    /// </summary>
    var me = this;

    try {
        if (me.error) {
            return false;
        }
        me.showInfo("", "", false);
        me.toggleMenu(me.visual.find(".button-toggle-active"));
        me.visual.find("#divMenu .button-toggle").off("click").on("click", function() {me.toggleMenu($(this))}).button();
        me.visual.find("#divFrame").height(parseInt(me.height - me.visual.find("#divCaption").height() - me.visual.find("#divMenu").height(), 10) -2);
        return true;
    } catch (ex) { me.writeError('init', ex); return false }
}

SignalAnalogSummary.prototype.toggleMenu = function (obj) {
    /// <summary>
    /// This function handles the opening of the clicked menu items<br/>
    /// </summary>
    var me = this;
    var h, w;
    var param;
    var random;
    try {
        if (me.error) {
            return false;
        }

        if (obj.data("type") !== "DS") {
            me.visual.find("#divMenu .button-toggle").removeClass("button-toggle-active");
            obj.addClass("button-toggle-active");

            h = parseInt(me.visual.find("#divFrame").outerHeight(), 10) - 10;
            w = parseInt(me.visual.find("#divFrame").width(), 10);

            //get a random vcgid
            random = parseInt(Math.random() * 100000, 10);
            //fill a new div with the random id into the frame 
            var detail = $("<div>").attr("id", "divFrameDetail" + random).height(h).width(w).html(me.vcC.getLoadingIcon());
            me.visual.find("#divFrame").html(detail);

        }
       
        switch (obj.data("type")) {
            case "INFO":
                param = { "bsaid": me.bsaid, 'tecDet': me.tecDet };
                me.vcVisual.addVisualBaseByName('divFrameDetail', "VISUAL_SIGNALANALOG_INFO1", random, getCurrentTimestamp(), h, w, "", JSON.stringify(param), me.deviceType);
             
                break;

            case "CONTACT":
              
                param = { "loggerid": me.blid };
                me.vcVisual.addVisualBaseByName('divFrameDetail', "WIDGET_PROJECT_CONTACTS", random, getCurrentTimestamp(), h, w, "", JSON.stringify(param), me.deviceType);
             
                break;


            case "HW":
                param = { "blhid": me.blhid, 'tecDet': me.tecDet };
                me.vcVisual.addVisualBaseByName('divFrameDetail', "VISUAL_UNIT_HARDWAREINFO", random, getCurrentTimestamp(), h, w, "", JSON.stringify(param), me.deviceType);
                break;
            case "UNIT":
                param = { "bluid": me.bluid};
                me.vcVisual.addVisualBaseByName('divFrameDetail', "VISUAL_UNIT_UNITINFO", random, getCurrentTimestamp(), h, w, "", JSON.stringify(param), me.deviceType);
                break;
            case "RULES":
                param = { "bsaid": me.bsaid, EditMode: false, ShowValidationIcons: false };
                me.vcVisual.addVisualBaseByName('divFrameDetail', "VISUAL_ANALOGSIGNALS_RULETHERMS", random, getCurrentTimestamp(), h-20, w, JSON.stringify(param), "", me.deviceType);
                break;
            //case "PLAUS":
            //    param = { "bsaid": me.bsaid, "loggerid": me.blid, "day": getCurrentTimestamp() , "showCharts":true};
            //    me.vcVisual.addVisualBaseByName('divFrameDetail', "VISUAL_DATACENTER_PLAUS", random, getCurrentTimestamp(), h, w, JSON.stringify(param), "", me.deviceType);

            //    break;
            case "ALARM":
                param = { "bsaid": me.bsaid};
                me.vcVisual.addVisualBaseByName('divFrameDetail', "WIDGET_EVENTS_ALARMINFO", random, getCurrentTimestamp(), h, w, "", JSON.stringify(param), me.deviceType);
                break;
            case "ALARMHISTORY":
                param = { "bsaid": me.bsaid, 'FixedContentHeight': true };
                me.vcVisual.addVisualBaseByName('divFrameDetail', "VISUAL_ALARMHISTORY", random, getCurrentTimestamp(), h, w, JSON.stringify(param), "", me.deviceType);
                break;
            //case "SANKEY":
            //    param = { interval: 3, datatype: 2, startDate: getCurrentTimestamp(), endDate: getCurrentTimestamp(), usePrices: false, dateUserDef: false };
            //    me.vcVisual.addVisualContentByName('divFrameDetail', "VISUAL_SIGNAL_SANKEY", random, getCurrentTimestamp(), h, w, "", JSON.stringify({ "signalID": me.bsaid, "archiveParam": param }), me.deviceType);
            //    break;
            case "INTERVENTION":
                param = { "bsaid": me.bsaid, "showAll":true, 'FixedContentHeight':true};
                me.vcVisual.addVisualBaseByName('divFrameDetail', "VISUAL_INTERVENTION_LIST", random, getCurrentTimestamp(), h, w, JSON.stringify(param), "", me.deviceType);
                break;
            case "TICKET":
              
                detail.height(detail.height() - 10);
                detail.TicketList({ invokeType: "addVisualBase", parameter: { "ReadOnlyMode": false, 'SignalID': me.bsaid, "LoggerID": me.blid }, deviceType: me.deviceType });
              break;
         
            case "COMMIT":
                param = { "bsaid": me.bsaid };
                me.vcVisual.addVisualBaseByName('divFrameDetail', "VISUAL_UNIT_CONFIGCOMMIT", random, getCurrentTimestamp(), h, w, JSON.stringify(param), "", me.deviceType);
                break;
            case "DS":

                me.vcVisual.showDsEdit2Dialog({ LoggerId: me.blid, bsaid: me.bsaid, day: moment(me.currentDate, 'DD.MM.YYYY HH:mm:ss').format('DD.MM.YYYY') });
             
                break;

            default:
        }
        return true;
    } catch (ex) { me.writeError('initClickHandler', ex); return false }
};

SignalAnalogSummary.prototype.specificInfoHandling = function (bError) {
    /// <summary>
    /// This function  hides/fades out content on error state. 
    /// </summary>
    var me = this;
    try {
        if (bError) {
            // me.visual.find('').hide();
        }
        return true;
    } catch (ex) {
        me.writeError('specificInfoHandling', ex);
        return false;
    }
};



function SignalAnalogInfo() {
    /// <summary>
    /// This object provides the javascript for the VC.Widget.Signal.SignalAnalog.Info.vb (an part of the devices visual and a part of the SignalAnalog.Summary visual).<br/>   
    /// Author: AFU<br />
    /// Date: 27.2.2017<br />
    /// Copyright ©: EUDT GmbH 2017 <br />
    /// Version-History:<br />
    /// **********************************************************************<br />
    /// *** v1.1.0 - 27.2.2017                                               *<br />
    /// **********************************************************************<br />
    /// * -  exctracted from serverside code                                 *<br />
    /// **********************************************************************<br />
    /// </summary>
}

SignalAnalogInfo.prototype = new vcTemplate();

SignalAnalogInfo.prototype.init = function () {
    /// <summary>
    /// This function loads the signal information<br/>
    /// </summary>
    var me = this;

    try {
        if (me.error) {
            return false;
        }
        window.VisualCoreService.getDataByName("VISUAL_UNIT_SYSTEMOVERVIEW", me.vcgid, getCurrentTimestamp(), me.height, me.width, "", "", me.deviceType, JSON.stringify({ "type": 1, "bsaid": me.bsaid }),
              function (result) {
               
                  me.visual.find('#sigTab').html(result);
                  result = null;
                  me.visual.find('.ti th').addClass('divHeader');
                  me.visual.find(".tecDet").toggle(me.tecDet);
                  me.visual.find('.fileView').unbind('click').click(function () {
                      showModalPopup("<div id='divMediaPopup1' class='frame' ></div>", 700, 394);
                      var media = {
                          mediaid: $(this).attr('data-id'),
                          height: 374,
                          width: 680,
                          pos: 'right',
                          show: true
                      };
                      me.vcVisual.addVisualContentByName('divMedia', 'VISUAL_FILEVIEWER', 'Popup1', getCurrentTimestamp(), 374, 680, JSON.stringify(media), '', 2);
                  });
                  return true;
              });
        return true;
    } catch (ex) { me.writeError('init', ex); return false }
}

SignalAnalogInfo.prototype.specificInfoHandling = function (bError) {
    /// <summary>
    /// This function  hides/fades out content on error state. 
    /// </summary>
    var me = this;
    try {
        if (bError) { me.visual.find('#sigTab').hide(); 
        }
        return true;
    } catch (ex) {
        me.writeError('specificInfoHandling', ex);
        return false;
    }
};




function SignalAnalogRuleTherms() {
    /// <summary>
    /// This object provides the javascript for the VC.Widget.Signal.SignalAnalog.RuleTherms.vb (an part of the devices visual and a part of the SignalAnalog.Summary visual).<br/>   
    /// Author: AFU<br />
    /// Date: 27.2.2018<br />
    /// Copyright ©: EUDT GmbH 2018 <br />
    /// Version-History:<br />
    /// **********************************************************************<br />
    /// *** v1.1.0 - 5.3.2018                                               *<br />
    /// **********************************************************************<br />
    /// * -  exctracted from serverside code                                 *<br />
    /// **********************************************************************<br />
    /// </summary>
}

SignalAnalogRuleTherms.prototype = new vcTemplate();

SignalAnalogRuleTherms.prototype.init = function () {
    /// <summary>
    /// This function inits the visual<br/>
    /// </summary>
    var me = this;

    try {
        if (me.error) {
            return false;
        }

        me.visual.find("#div-list").height(parseInt(me.height - me.visual.find("#div-menu").height(),10)-20);
    
        me.visual.find("#vc-cal").vcDateBox({ mode: "Single", align: "center", interval: 1, langID: me.userLangidForCulture});
        me.initEvents();

        me.visual.off('click', ".btnSignalInfo").on('click', ".btnSignalInfo", function (e) {
            var bsaid = parseInt($(this).attr("data-id"), 10);
            me.vcVisual.showSignalAnalogSummaryDialog(bsaid);
            e.stopPropagation();
        });

        me.visual.off('click', ".btnMainItem").on('click', ".btnMainItem", function () { me.reload(); });

        return true;
    } catch (ex) { me.writeError('init', ex); return false }
}


SignalAnalogRuleTherms.prototype.initEvents = function () {
    /// <summary>
    /// This function inits click and hover events<br/>
    /// </summary>
    var me = this;

    try {
        if (me.error) {
            return false;
        }


        me.visual.find('.btnEditDay').on('click', function () {
            var id = parseInt($(this).attr('data-id'), 10);
            _VCMQ.produce(me.visual, me.vcgid, 'SELECT_SINGLE_SIGNAL', { 'id': id, 'day': me.day });
        });

        me.visual.find('.btnChangeProject').on('click', function () {
            var id = parseInt($(this).attr('data-id'), 10);
            me.changeProjectDialog( { 'id': id, 'day': me.day });
        });

        me.visual.off('click', ".btnPlaus").on('click', ".btnPlaus", function () {
            var bsaid = parseInt($(this).attr("data-id"), 10);
            var blid = parseInt($(this).attr("data-blid"), 10);

            if ($(this).parents(".box").find(".div-edit-plaus[data-id=" + bsaid + "]").hasClass("visible")) {
                $(this).parents(".box").find(".div-edit-plaus[data-id=" + bsaid + "]").removeClass("visible").hide().html("");
               
            } else {
                $(this).parents(".box").find(".div-edit-plaus[data-id=" + bsaid + "]").addClass("visible").show();
               
                var param = { "bsaid": bsaid, "loggerid": blid, "day": me.day };
                me.vcVisual.addVisualBaseByName('div-edit-plaus_', 'VISUAL_DATACENTER_PLAUS', blid + "_" + bsaid, getCurrentTimestamp(), 700, 1000, JSON.stringify(param), '', 1);
            }
        });

        me.visual.find(".node").mouseover(function () {
            me.visual.find(".node").removeClass("color-font-secondary color-font-primary mark");
            me.visual.find(".signal").removeClass("color-font-primary mark");
            var l = $(this).data("level");
            $(this).addClass("color-font-secondary mark");
            $(this).parents(".rule" + l).find(".node" + (l + 1)).addClass("color-font-secondary mark");
            $(this).parents(".rule" + l).find(".signal").addClass("color-font-primary mark");
        }).mouseout(function () {
            me.visual.find(".node").removeClass("color-font-secondary color-font-primary mark");
            me.visual.find(".signal").removeClass("color-font-primary mark");
        });


        return true;
    } catch (ex) { me.writeError('initHoverEvents', ex); return false }
}

SignalAnalogRuleTherms.prototype.changeProjectDialog = function (event) {
    /// <summary>
    /// This function opens a modal dialog for saving data.<br/>
    /// </summary>
    var me = this;
    try {
        //optional stuff done before the saving
        //set in the accoring inherited classes
       // me.prepareSaveDialog();

        var dialog = $('<p>' + me.resources.changeProject + '</p>').dialog({
            title: me.resources.dialogTitle, modal: true,
            buttons: {
                "Yes": function () {
                    _VCMQ.produce(me.visual, me.vcgid, 'OPEN_SELECTED_PROJECT', event);
                    dialog.dialog('close');
                },
                "Cancel": function () { dialog.dialog('close'); return false; }
            },
            dialogClass: 'saveDialog'
        });
        // ReSharper disable InvalidValue
        $('.saveDialog .ui-button-text:contains(YES)').text(me.resources.yes);
        $('.saveDialog .ui-button-text:contains(CANCEL)').text(me.resources.cancel);
        // ReSharper restore InvalidValue
        return false;
    } catch (ex) { me.writeError('saveDialog', ex); return false; }
};


SignalAnalogRuleTherms.prototype.reload = function () {
    /// <summary>
    /// This function reloads the list <br/>
    /// </summary>
    var me = this;
    try {
        if (me.error) { return false; }
        me.visual.find("#div-list").html(me.vcC.getLoadingIcon());

        var dates = me.visual.find("#vc-cal").vcDateBox("getDate");
        me.day = dates.from;


        window.VisualCoreService.getData(me.vcvid, me.vcgid, me.day, me.height, me.width, me.param, "", me.deviceType, me.langid, JSON.stringify({ 'type': 1 }),
            function (result) {
                if (result === '') { result = me.resources.err_loadData }
                me.visual.find("#div-list").html(result);
                me.initEvents();
                return false;
            });
    } catch (ex) { me.writeError('reload', ex); return false; }
    return true;
}




SignalAnalogRuleTherms.prototype.specificInfoHandling = function (bError) {
    /// <summary>
    /// This function  hides/fades out content on error state. 
    /// </summary>
    var me = this;
    try {
        if (bError) {
            me.visual.find('#div-menu, #div-list').hide();
        }
        return true;
    } catch (ex) {
        me.writeError('specificInfoHandling', ex);
        return false;
    }
};
